
import {
  AceDarkPanelShell,
  aceDarkChipActiveClass,
  aceDarkChipClass,
  aceDarkChipInactiveClass,
  aceDarkDividerClass,
  aceDarkInputClass,
} from '@/components/help-center/aces/AceDarkPanelShell';
import { AceSortDropdown } from '@/components/help-center/aces/AceSortDropdown';
import type { AceFilterId, AceSortId } from '@/lib/aces-data';
import { cn } from '@/lib/utils';
import { Search, SlidersHorizontal } from 'lucide-react';

const FILTERS: { id: AceFilterId; label: string }[] = [
  { id: 'all', label: 'Todos' },
  { id: 'account', label: 'Conta' },
  { id: 'chat', label: 'Chat' },
  { id: 'with-levels', label: 'Com níveis' },
  { id: 'without-levels', label: 'Sem níveis' },
];

const SORTS: { id: AceSortId; label: string }[] = [
  { id: 'recent', label: 'Mais recentes' },
  { id: 'name', label: 'Nome' },
  { id: 'popularity', label: 'Popularidade' },
];

type AcesFilterBarProps = {
  query: string;
  onQueryChange: (value: string) => void;
  filter: AceFilterId;
  onFilterChange: (value: AceFilterId) => void;
  sort: AceSortId;
  onSortChange: (value: AceSortId) => void;
  resultCount: number;
};

export function AcesFilterBar({
  query,
  onQueryChange,
  filter,
  onFilterChange,
  sort,
  onSortChange,
  resultCount,
}: AcesFilterBarProps) {
  return (
    <AceDarkPanelShell innerClassName="p-4 md:p-5">
      <div className="flex flex-col gap-4 lg:flex-row lg:items-center lg:justify-between">
        <div className="relative min-w-0 flex-1 lg:max-w-md">
          <Search className="pointer-events-none absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-amber-200/70" />
          <input
            type="search"
            value={query}
            onChange={(e) => onQueryChange(e.target.value)}
            placeholder="Pesquisar Aces..."
            className={cn(
              aceDarkInputClass,
              'w-full py-2.5 pl-10 pr-4 font-inter text-sm text-blue-50 placeholder:text-blue-200/35'
            )}
          />
        </div>

        <p className="shrink-0 font-inter text-sm text-blue-100/60">
          {resultCount} {resultCount === 1 ? 'Ace encontrado' : 'Aces encontrados'}
        </p>
      </div>

      <div
        className={cn(
          'mt-4 flex flex-col gap-4 border-t pt-4 md:flex-row md:items-center md:justify-between',
          aceDarkDividerClass
        )}
      >
        <div className="flex flex-wrap items-center gap-2">
          <span className="mr-1 flex items-center gap-1.5 font-poppins text-xs font-semibold uppercase tracking-wide text-amber-200/75">
            <SlidersHorizontal className="h-3.5 w-3.5" />
            Filtros
          </span>
          {FILTERS.map((item) => (
            <button
              key={item.id}
              type="button"
              onClick={() => onFilterChange(item.id)}
              className={cn(
                aceDarkChipClass,
                filter === item.id ? aceDarkChipActiveClass : aceDarkChipInactiveClass
              )}
            >
              {item.label}
            </button>
          ))}
        </div>

        <div className="flex flex-wrap items-center gap-2">
          <span className="font-poppins text-xs font-semibold uppercase tracking-wide text-amber-200/75">
            Ordenar
          </span>
          <AceSortDropdown value={sort} options={SORTS} onChange={onSortChange} />
        </div>
      </div>
    </AceDarkPanelShell>
  );
}
